import React, { useState } from "react";
import { Alert, Button, Col, Form, Input, Row } from "antd";
import { _post } from "../services/service_api";
import { API_BASE_URL, CREATE_HOSPITAL } from "../services/end_points";
const AddHospital = ({ updateUserList }) => {
  const [alert, setAlert] = useState();
  const [formdata, setFormdata] = useState({
    hospitalName: "",
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await _post(
        `${API_BASE_URL}${CREATE_HOSPITAL}`,
        formdata
      );
      updateUserList(response.data);
      setFormdata({ hospitalName: "" });

      if (response.status == 201) {
        setAlert(true);
      }
    } catch (err) {
      console.error("Error details:", err);
      setAlert(false);

      if (err.response) {
        console.error("Server responded with status:", err.response.status);
        console.error("Response data:", err.response.data);
      } else if (err.request) {
        console.error("No response received:", err.request);
      } else {
        console.error("Error setting up request:", err.message);
      }
    }
  };

  const handleReset = () => {
    setFormdata({ hospitalName: "" });
  };
  return (
    <>
      <Row>
        <Form onFinish={handleSubmit} layout="vertical">
          {alert && (
            <div>
              <Alert
                type="success"
                style={{
                  backgroundColor: "#dff0d8",
                  color: "green",
                  fontSize: "16px",
                  borderColor: "#dff0d8",
                  textAlign: "center",
                }}
                message={"Hospital Created!"}
              />
            </div>
          )}
          <Col
            md={20}
            xl={24}
            lg={24}
            sm={24}
            style={{
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Form.Item label="Add Hospital Name" required>
              <Input
                id="HospitalName"
                name="hospitalName"
                value={formdata.hospitalName}
                onChange={handleFormChange}
                style={{ width: "100%" }}
              />
            </Form.Item>

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1rem", // Adjust spacing as needed
                width: "20vw",
              }}
            >
              <Button
                type="button"
                onClick={handleReset}
                style={{
                  color: "black",
                  border: "solid #1236fa",
                  marginRight: "auto",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Reset
              </Button>
              <Button
                type="submit"
                onClick={handleSubmit}
                style={{
                  color: "white",
                  background: "#1236fa",
                  width: "85px",
                  height: "32px",
                  borderRadius: "3vw",
                }}
              >
                Submit
              </Button>
            </div>
          </Col>
        </Form>
      </Row>
    </>
  );
};

export default AddHospital;
